import React, { useState, useEffect, useRef } from 'react';
import translate from '../../data/translations';
import { SplitButtonOption } from './optionInterface';

interface SplitButtonProps {
    options: SplitButtonOption[];
    selectedItem?: SplitButtonOption;
    onSelect: (selectedOption: string | number) => void;
    styleProp?: object;
}

function SplitButton({ options, selectedItem, onSelect, styleProp = {} }: SplitButtonProps) {
    const [isOpen, setIsOpen] = useState(false);
    const [selectedOption, setSelectedOption] = useState(selectedItem || options[0]);
    const selectRef = useRef<HTMLDivElement>(null); // Add the type for selectRef

    const handleOptionClick = (option: SplitButtonOption) => {
        setSelectedOption(option);
        setIsOpen(false);
        onSelect(option.value);
    };

    const handleDocumentClick = (event: MouseEvent) => {
        if (selectRef.current && !selectRef.current.contains(event.target as Node)) {
            setIsOpen(false);
        }
    };

    useEffect(() => {
        if (selectedItem) {
            setSelectedOption(selectedItem);
        }
    }, [selectedItem]);

    useEffect(() => {
        document.addEventListener('click', handleDocumentClick);

        return () => {
            document.removeEventListener('click', handleDocumentClick);
        };
    }, []);

    return (
        <div className="custom-split-button-select" style={{ ...styleProp }} ref={selectRef}>
            <div className={`select-header ${isOpen ? 'open' : ''}`} onClick={() => setIsOpen(!isOpen)}>
                {translate(selectedOption.label)}
            </div>
            {isOpen && (
                <div className="custom-split-button-options-wrapper">
                    {options.map((option, ind) => (
                        <div
                            key={ind}
                            className={`custom-split-button-option ${
                                option.value === selectedOption.value ? 'selected' : 'custom-split-button-option'
                            }`}
                            onClick={() => handleOptionClick(option)}
                        >
                            {translate(option.label)}
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
}
export default SplitButton;
